export default {
  title: 'Orders',
};
